<template>
  <div>
    <v-card rounded="xl" class="elevation-2">
      <v-card-title class="pb-0">
        <v-icon color="primary" class="mr-2">mdi-qrcode-scan</v-icon>
        Escáner de Entrada QR
        <v-spacer />
        <v-chip small color="success" dark v-if="visitasHoy > 0">
          {{ visitasHoy }} entrada(s) hoy
        </v-chip>
      </v-card-title>
      <v-card-subtitle>
        Escanea el QR del carnet del miembro para registrar su entrada
      </v-card-subtitle>
      <v-divider />
      <v-card-text>
        <escanerQR
          :idUsuario="idUsuario"
          @visita-registrada="onVisitaRegistrada"
        />
      </v-card-text>
    </v-card>

    <!-- Últimas entradas del día -->
    <v-card rounded="xl" class="mt-4 elevation-2" v-if="ultimasVisitas.length">
      <v-card-title class="text-subtitle-1 font-weight-bold">
        <v-icon color="teal" class="mr-2">mdi-history</v-icon>
        Últimas entradas de hoy
      </v-card-title>
      <v-divider />
      <v-list dense>
        <v-list-item v-for="(v, i) in ultimasVisitas" :key="i">
          <v-list-item-avatar size="36">
            <v-img :src="v.imagen || ''" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ v.nombre }}</v-list-item-title>
            <v-list-item-subtitle>{{ v.matricula }} · {{ v.membresia }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-chip x-small :color="v.estado === 'ACTIVO' ? 'success' : 'error'" dark>
              {{ v.estado }}
            </v-chip>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import EscanerQR from './Visitas/EscanerQR.vue'

export default {
  name: 'EscanerPage',
  components: { EscanerQR },

  data() {
    return {
      idUsuario:     parseInt(localStorage.getItem('idUsuario') || '0'),
      visitasHoy:    0,
      ultimasVisitas: [],
    }
  },

  methods: {
    onVisitaRegistrada(miembro) {
      this.visitasHoy++
      this.ultimasVisitas.unshift(miembro)
      if (this.ultimasVisitas.length > 10) this.ultimasVisitas.pop()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/EscanerPage.vue